import moment from 'moment';
import { useState } from 'react';
import { camelCase } from 'lodash';
import { useTranslation } from 'react-i18next';
import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { formatByMask } from 'src/common/helpers/common.helpers';
import { File, IApplicant } from 'src/pages/vacancies/vacancies.interfaces';

import { InterviewFormWrapper, InfoBlock, InfoElement } from './applicant-details-info.styles';
import { PreviewDocumentModal } from './components/preview-document-modal';
import { FileElement } from './components/file-element';

const ApplicantDetailsInfo = ({ applicant }: { applicant: IApplicant }) => {
  const { t } = useTranslation(['common', 'vacancies']);
  const [document, setDocument] = useState<File | null>(null);
  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    status,
    createdAt,
    documents,
    availableFrom,
    salaryExpectations,
  } = applicant;

  return (
    <InterviewFormWrapper>
      {!!document && (
        <PreviewDocumentModal
          isOpened={!!document}
          onClose={() => setDocument(null)}
          document={document}
        />
      )}
      <InfoBlock>
        <InfoElement>
          <Typography weight="bold">{t('common:labels.firstName')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{firstName}</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('common:labels.lastName')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{lastName}</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('common:labels.email')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{email}</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('common:labels.phoneNumber')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {formatByMask(phoneNumber, '+## ### ### #######')}
          </Typography>
        </InfoElement>
      </InfoBlock>
      <InfoBlock>
        <InfoElement>
          <Typography weight="bold">{t('vacancies:labels.availableFrom')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {moment(availableFrom).format('DD.MM.YYYY')}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('vacancies:labels.salaryExpectations')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {salaryExpectations || '-'}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('common:labels.status')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t(`vacancies:labels.applicantsStatuses.${camelCase(status)}`)}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('vacancies:labels.applicationDate')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {moment(createdAt).format('DD.MM.YYYY')}
          </Typography>
        </InfoElement>
      </InfoBlock>
      <InfoBlock>
        <FileElement
          data={documents.resumeFiles}
          title={t('vacancies:labels.cv')}
          setFile={file => setDocument(file)}
        />
        <FileElement
          data={documents.salutationFiles}
          title={t('customers:labels.salutation')}
          setFile={file => setDocument(file)}
        />
      </InfoBlock>
    </InterviewFormWrapper>
  );
};

export default ApplicantDetailsInfo;
